import React, { useCallback, useEffect, useState } from "react";
import { Flag } from "@phosphor-icons/react";
import api from "@/lib/api";
import { BTN_WHITE } from "@/components/pageSettings/AdminModal";
import { NewUserWizard } from "@/components/user-wizard/NewUserWizard";
import { CheckRow, StepList } from "./LaunchSteps";

const HIDE_KEY = "launch-guide-hidden";

// Short go-live checklist + first buyer / media buyer walkthrough, shown after a clean start.
export function LaunchGuide() {
  const [data, setData] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem(HIDE_KEY) === "1");
  const [wizard, setWizard] = useState(false);
  const load = useCallback(() => api.get("/admin/launch-guide").then((r) => setData(r.data)).catch(() => setData(null)), []);
  useEffect(() => { load(); }, [load]);
  if (!data || (!data.clean_start_done && data.all_done)) return null;
  const toggle = () => { localStorage.setItem(HIDE_KEY, hidden ? "0" : "1"); setHidden(!hidden); };
  const pct = Math.round((100 * data.done) / Math.max(data.total, 1));
  const closeWizard = () => { setWizard(false); load(); };
  return (
    <section className="mb-6 border-2 border-black bg-white p-4 shadow-[4px_4px_0_0_#000]" data-testid="launch-guide">
      <div className="flex flex-wrap items-center gap-3">
        <Flag size={22} weight="bold" />
        <div className="mr-auto">
          <div className="label-mono">{data.clean_start_done ? "After your clean start" : "Launch guide"}</div>
          <div className="font-chivo text-xl font-black leading-tight">Go live, step by step</div>
        </div>
        <span className={`px-2 py-1 text-[11px] uppercase tracking-widest ${data.all_done ? "bg-emerald-600 text-white" : "border border-black"}`}
              data-testid="launch-guide-status">
          {data.all_done ? "All set" : `${data.done} of ${data.total} done`}
        </span>
        {!hidden && <button type="button" className={BTN_WHITE} onClick={load} data-testid="launch-guide-refresh">Re-check</button>}
        <button type="button" className={BTN_WHITE} onClick={toggle} data-testid="launch-guide-toggle">{hidden ? "Show" : "Hide"}</button>
        <div className="h-2 w-full border border-black bg-white" data-testid="launch-guide-progress">
          <div className="h-full bg-emerald-600 transition-[width] duration-500" style={{ width: `${pct}%` }} />
        </div>
      </div>
      {!hidden && (
        <div className="mt-4 grid gap-6 lg:grid-cols-3">
          <div data-testid="launch-checks">
            <div className="label-mono">Go-live checklist</div>
            <ul className="divide-y divide-zinc-200">{data.checks.map((c) => <CheckRow key={c.key} c={c} />)}</ul>
          </div>
          <StepList title="First buyer" name={data.buyer.name} steps={data.buyer.steps} group="buyer" onWizard={() => setWizard(true)} />
          <StepList title="First media buyer" name={data.media_buyer.name} steps={data.media_buyer.steps} group="media"
                    onWizard={() => setWizard(true)} />
        </div>
      )}
      <NewUserWizard open={wizard} onClose={closeWizard} />
    </section>
  );
}
